import { Directive, OnInit, inject, input } from '@angular/core';

import { ThemeOptionsWithDefault, getByThemeOrDefault, injectCurrentTheme } from '@frontend/sports/common/ui/shared';
import { DsSegmentedControl } from '@frontend/ui/segmented-control';

@Directive({
    selector: '[msThemedSegmentedControl]',
    standalone: true,
})
export class SportsThemedSegmentedControlDirective implements OnInit {
    dsSegmentedControl = inject(DsSegmentedControl, { self: true });
    currentTheme = injectCurrentTheme();

    themeInverse = input.required<ThemeOptionsWithDefault<boolean>>();

    ngOnInit(): void {
        this.dsSegmentedControl.inverse = !!getByThemeOrDefault(this.themeInverse(), this.currentTheme);
    }
}
